var _path, _rect, _path2, _rect2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _rect4, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 435,
    height: 522,
    viewBox: "0 0 435 522",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M322.425 0L435 115H38V0H322.425Z",
    fill: "#FAFAFD"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 115,
    width: 397,
    height: 407,
    fill: "#FAFAFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M322.5 115H435L322.5 0V115Z",
    fill: "#DEE2E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 338,
    y: 115,
    width: 97,
    height: 16,
    fill: "#E9ECEF",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.323 123C135.027 172.113 170.627 224.708 214.5 279.291C275.856 355.627 338.19 411.736 396 452.359V459.791C396 477.464 381.673 491.791 364 491.791H110C92.3269 491.791 78 477.464 78 459.791V154.791C78 138.361 90.3819 124.824 106.323 123Z",
    fill: "#E9ECEF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M387 370H87V388H387V370Z",
    fill: "url(#paint0_linear_106_1050)",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M275.5 278H87V296H275.5V278Z",
    fill: "url(#paint1_linear_106_1050)",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M275.5 195H87V213H275.5V195Z",
    fill: "url(#paint2_linear_106_1050)",
    fillOpacity: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M275.5 236H87V254H275.5V236Z",
    fill: "url(#paint3_linear_106_1050)",
    fillOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M387 425H87V443H387V425Z",
    fill: "url(#paint4_linear_106_1050)",
    fillOpacity: 0.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 20,
    width: 278,
    height: 111,
    fill: "#6C757D"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 218,
    height: 31,
    fill: "#E9ECEF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_106_1050)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.3026 51.7841V41.1818H102.007V51.7841H80.4276V111H67.8821V51.7841H46.3026ZM123.314 41.1818L138.689 66.75H139.234L154.678 41.1818H169.098L147.587 76.0909L169.439 111H154.78L139.234 85.6023H138.689L123.143 111H108.553L130.609 76.0909L108.825 41.1818H123.314ZM175.959 51.7841V41.1818H231.663V51.7841H210.084V111H197.538V51.7841H175.959Z",
    fill: "#FAFAFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_106_1050",
    x: 34.3008,
    y: 41.1836,
    width: 201.363,
    height: 85.8164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_106_1050"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_106_1050",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_106_1050",
    x1: 237,
    y1: 195,
    x2: 237,
    y2: 443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#495057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_106_1050",
    x1: 237,
    y1: 195,
    x2: 237,
    y2: 443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#495057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_106_1050",
    x1: 237,
    y1: 195,
    x2: 237,
    y2: 443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#495057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_106_1050",
    x1: 237,
    y1: 195,
    x2: 237,
    y2: 443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#495057"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_106_1050",
    x1: 237,
    y1: 195,
    x2: 237,
    y2: 443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C757D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#495057"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.729b13e2a6fb7f16b189bd63a1c8dd3a.svg";
export { ForwardRef as ReactComponent };